import permissions from './permission-list'

export default [
  {
    path: '/article-categories',
    name: 'article-categories',
    component: () => import('@/views/article-categories/index.vue'),
    meta: {
      pageTitle: 'Daftar Kategori Artikel',
      resource: permissions.articleCategory,
      action: 'read',
      navActiveLink: 'article-categories',
      breadcrumb: [
        {
          text: 'Kategori Artikel',
          active: true,
        },
      ],
    },
  },
  {
    path: '/article-categories/create',
    name: 'article-categories-create',
    component: () => import('@/views/article-categories/create.vue'),
    meta: {
      pageTitle: 'Buat Kategori Artikel',
      resource: permissions.articleCategory,
      action: 'manage',
      navActiveLink: 'article-categories',
      breadcrumb: [
        {
          text: 'Kategori Artikel',
          active: false,
          to: { path: '/article-categories' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/article-categories/:id/edit',
    name: 'article-categories-edit',
    component: () => import('@/views/article-categories/edit.vue'),
    meta: {
      pageTitle: 'Edit Kategori Artikel',
      resource: permissions.articleCategory,
      action: 'manage',
      navActiveLink: 'article-categories',
      breadcrumb: [
        {
          text: 'Kategori Artikel',
          active: false,
          to: { path: '/article-categories' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
